import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid, Card, CardContent, Typography } from '@mui/material';
import RoleGuard from '../../components/Auth/RoleGuard';

// Import role-specific dashboard components
import AdminDashboard from './AdminDashboard';
import StaffDashboard from './StaffDashboard';
import CitizenDashboard from './CitizenDashboard';
import OfficerDashboard from './OfficerDashboard';

const RoleBasedDashboard = () => {
  const { role } = useSelector((state) => state.auth);
  
  return (
    <Box>
      {/* Admin Dashboard */}
      <RoleGuard allowedRoles={['admin']} showError={false}>
        <AdminDashboard />
      </RoleGuard>

      {/* Staff Dashboard */}
      <RoleGuard allowedRoles={['l1_staff']} showError={false}>
        <StaffDashboard />
      </RoleGuard>

      {/* Citizens Dashboard */}
      <RoleGuard allowedRoles={['citizen']} showError={false}>
        <CitizenDashboard />
      </RoleGuard>

      {/* Department Officers Dashboard */}
      <RoleGuard allowedRoles={['dc', 'sdm', 'dpo', 'reve_o', 'ahvs_h', 'agri_h', 'horti_h']} showError={false}>
        <OfficerDashboard />
      </RoleGuard>

      {/* Field Inspectors Dashboard */}
      <RoleGuard allowedRoles={['reve_i', 'ahvs_i', 'agri_i', 'horti_i']} showError={false}>
        <Box>
          <Typography variant="h4" gutterBottom>
            Field Inspector Dashboard
          </Typography>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, mb: 6 }}>
              <Card>
                <CardContent>
                  <Typography variant="h6" color="primary">
                    Pending Inspections
                  </Typography>
                  <Typography variant="h4">
                    12
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid size={{ xs: 12, mb: 6 }}>
              <Card>
                <CardContent>
                  <Typography variant="h6" color="primary">
                    Completed This Month
                  </Typography>
                  <Typography variant="h4">
                    28
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </RoleGuard>

      {/* Accounts Dashboard */}
      <RoleGuard allowedRoles={['accounts']} showError={false}>
        <Box>
          <Typography variant="h4" gutterBottom>
            Accounts Dashboard
          </Typography>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12 }} mb={4}>
              <Card>
                <CardContent>
                  <Typography variant="h6" color="primary">
                    Pending Disbursements
                  </Typography>
                  <Typography variant="h4">
                    ₹25,50,000
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid size={{ xs: 12 }} mb={4}>
              <Card>
                <CardContent>
                  <Typography variant="h6" color="primary">
                    Processed This Month
                  </Typography>
                  <Typography variant="h4">
                    ₹1,20,00,000
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid size={{ xs: 12 }} mb={4}>
              <Card>
                <CardContent>
                  <Typography variant="h6" color="primary">
                    Pending Cheques
                  </Typography>
                  <Typography variant="h4">
                    45
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </RoleGuard>

      {/* Default Dashboard for unknown roles */}
      {!['admin', 'l1_staff', 'citizen', 'dc', 'sdm', 'dpo', 'reve_o', 'ahvs_h', 'agri_h', 'horti_h', 'reve_i', 'ahvs_i', 'agri_i', 'horti_i', 'accounts'].includes(role?.name) && (
        <Box>
          <Typography variant="h4" gutterBottom>
            Welcome to NC Ex-Gratia System
          </Typography>
          <Card>
            <CardContent>
              <Typography variant="body1">
                Your role ({role?.name || 'Unknown'}) doesn't have a specific dashboard configured yet.
                Please contact your administrator for access.
              </Typography>
            </CardContent>
          </Card>
        </Box>
      )}
    </Box>
  );
};

export default RoleBasedDashboard;
